import { MobileMapView } from '@/components/mobile/MobileMapView';
import { type RestaurantWithProduct } from '@/types';
import { type OrderType } from '@/lib/operatingHours';

interface DesktopMapViewProps {
  restaurants: RestaurantWithProduct[];
  selectedOrderType: OrderType;
}

export function DesktopMapView({ restaurants, selectedOrderType }: DesktopMapViewProps) {
  // Simply reuse MobileMapView with desktop-specific wrapper
  return (
    <div className="w-full h-full">
      <MobileMapView 
        restaurants={restaurants} 
        selectedOrderType={selectedOrderType}
      />
    </div>
  );
}